import Search from "@client/controls/Inputs/Search/component";
import Select from "@client/controls/Inputs/Select/component";
import { type OptionItem, ScreenType } from "@client/types";
import { useI18n } from "@common/hooks/i18n";
import { useUpdated } from "@common/lib/hooks";
import classNames from "classnames";
import * as React from "react";

export interface ProductListFiltersMapProps {
  categoryId: string | null;
  categoryOptions: OptionItem[];
  eventId: string | null;
  events: OptionItem[];
  fieldStyle: React.CSSProperties;
  isEventsVisible: boolean;
  orders: OptionItem[];
  order: string;
  pageSize: number;
  screenType: ScreenType;
  searchText: string;
}

export interface ProductListFiltersActionProps {
  onCategoryIdChange: (categoryId: string | null) => void;
  onEventChange: (eventId: string | null) => void;
  onOrderByChange: (order: string) => void;
  onPageSizeChange: (pageSize: number) => void;
  onSearch: () => void;
  onSearchTextChange: (searchText: string) => void;
}

export type ProductListFiltersProps = ProductListFiltersActionProps & ProductListFiltersMapProps;

const ProductListFilters = (props: ProductListFiltersProps) => {
  const i18n = useI18n();

  // TODO: figure out why props.onCategoryIdChange changes when a category is selected
  useUpdated(() => {
    if (props.categoryOptions.length === 1) {
      props.onCategoryIdChange(props.categoryOptions[0].value);
    } else {
      props.onCategoryIdChange(null);
    }
  }, [props.categoryOptions.length]);

  useUpdated(() => {
    props.onPageSizeChange(props.pageSize);
  }, [props.pageSize]);

  const onClear = React.useCallback(() => {
    props.onSearchTextChange("");
    props.onSearch();
  }, [props.onSearch, props.onSearchTextChange]);

  return (
    <div className={classNames("wsc_product_list_filters", props.screenType)}>
      {props.isEventsVisible && (
        <Select
          className="order-by"
          blankOptionLabel={i18n.infoSelectEvent}
          onChange={props.onEventChange}
          options={props.events}
          sort="asc"
          style={props.fieldStyle}
          value={props.eventId}
        />
      )}
      {props.orders.length > 1 && (
        <Select
          className="order-by"
          onChange={props.onOrderByChange}
          options={props.orders}
          style={props.fieldStyle}
          value={props.order}
        />
      )}
      {props.categoryOptions.length > 1 && (
        <Select
          className="category"
          blankOptionLabel={i18n.infoSelectCategory}
          emptyLabel={i18n.allProducts}
          emptyValue={null}
          onChange={props.onCategoryIdChange}
          options={props.categoryOptions}
          sort="asc"
          style={props.fieldStyle}
          value={props.categoryId}
        />
      )}
      <div className="gap" />
      <Search
        onChange={props.onSearchTextChange}
        onEnter={props.onSearch}
        onClear={onClear}
        showEnter
        style={props.fieldStyle}
        value={props.searchText}
      />
    </div>
  );
};

export default ProductListFilters;
